import React from "react";
import { ErrorType } from "../errorboundaries";

export const ErrorBoundaryContext = React.createContext((obj: ErrorType) => {});
export const useErrorHandling = () => {
  return React.useContext(ErrorBoundaryContext);
};
